module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/promos/promo.component.scss
// module id = ./src/app/promos/promo.component.scss
// module chunks = main